import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { environment } from '../../../../../environments/environment';
import { PendingProviderSelectionService } from '../../../../core/services';
import { ClientService } from '../../../../core/services/client.service';
import { Client } from '../../../../domain/models';
import { AuthPopupService, AuthService } from '../../../auth/services';
import { Program } from '../../models';
import { ProgramService } from '../../services/program.service';
import { ProgramCardComponent } from '../program-card/program-card.component';

@Component({
    selector: 'app-program-card-collection',
    templateUrl: './program-card-collection.component.html',
    styleUrls: ['./program-card-collection.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslocoModule,
        ProgramCardComponent,
        FlexLayoutModule,
        MatButtonModule
    ]
})
export class ProgramCardCollectionComponent implements OnInit {
    client: Client | undefined;
    programs: Program[] | undefined;
    selectedPrograms: Program[] = [];
    selectedProgramIds: number[] = [];

    constructor(
        private programService: ProgramService,
        private router: Router,
        private readonly _authPopup: AuthPopupService,
        private readonly _auth: AuthService,
        private readonly _client: ClientService,
        private readonly _pendingSelection: PendingProviderSelectionService
    ) {}

    ngOnInit() {
        this.programService.getPrograms().subscribe((res) => {
            this.programs = res;

            this.programs.forEach((program: Program) => {
                // prepend API URL
                if (program.logoPath)
                    program.logoPath = `${environment.apiUrl}${program?.logoPath}`;
            });
        });

        this._client.latest.subscribe((client) => {
            if (!client) return;
            this.client = client;
        });
    }

    updateSelectedPrograms(program: Program) {
        let programId: number = program.programId ?? 0;

        if (programId !== 0) {
            if (this.selectedProgramIds.indexOf(programId) == -1) {
                this.selectedPrograms.push(program);
                this.selectedProgramIds.push(programId);
            } else {
                this.selectedPrograms.splice(
                    this.selectedProgramIds.indexOf(programId),
                    1
                );
                this.selectedProgramIds.splice(
                    this.selectedProgramIds.indexOf(programId),
                    1
                );
            }
        }
    }

    searchProviders() {
        // Hand the chosen programs to the provider search as a filter.
        this._pendingSelection.setProgramFilterIds(this.selectedProgramIds);

        // navigate to providers
        this.router.navigateByUrl(`${runtimeConfig.clientCode}/provider`);
    }

    navigation(route: string) {
        this.router.navigateByUrl(`${runtimeConfig.clientCode}/${route}`);
    }

    startApplication(): void {
        // Only the waitlist marker is stored.  This used to also overwrite the staged provider
        // selection with the client-level waitlist, replacing the provider a deep-linked student
        // had arrived with; sign-up is what promotes the waitlist, and only when there is one
        // (LA-22939).
        this._pendingSelection.setWaitlistProviderIds(
            this.client?.waitlistProviderIds ?? []
        );

        //Signup and/or start the application
        if (this._auth.isSignedIn)
            this.router.navigateByUrl(`${this.client?.clientCode}/application`);
        else {
            this._authPopup.showAccountCreation();
        }
    }
}
